
import { Component, Mixins } from "vue-property-decorator";
import { ILineGraphBehavior, LineGraphBehavior } from "../../../../../../documaker/domain/format/objects";
import { ILineGraphBehaviorPropertyEditable, instanceOfILineGraphBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class LineGraphBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ILineGraphBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ILineGraphBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isLineGraphBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfILineGraphBehaviorPropertyEditable(s) && s.lineGraphBehavior().isEditable(), false);
  }

  get lineGraphBehavior(): ILineGraphBehavior {
    return this.readPropertyOrDefault(s => s.lineGraphBehavior().getValue(), new LineGraphBehavior());
  }

  set lineGraphBehavior(value: ILineGraphBehavior) {
    this.writePropertyWhenValid(s => s.lineGraphBehavior().setValue(value));
  }

  get lineGraphValueTypes(): string[] {
    return this.readPropertyOrDefault(s => s.getLineGraphValueTypes(), []);
  }
}
